<template>
    <div class="positionEditBox">
        <el-form :model="form" label-width="100px" ref="positionEditBox" :rules="modalForm" class="editRolesDialogForm">
            <el-form-item label="职位名称:" prop="jobName">
                <el-input class="w400" v-model="form.jobName" placeholder="如：【上海+SSPACE Studio】招募少儿POPPING老师" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="招聘类型:" prop="jobType">
                <el-select v-model="form.jobType">
                    <el-option v-for="item in typeData" :label="item.value" :value="item.key" :key="item.kay"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="职位薪资:">
                <el-select v-model="form.salaryType">
                    <el-option v-for="item in modeData" :label="item.value" :value="item.key" :key="item.kay"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="薪资范围:" v-if="form.salaryType == 1" required>
                <el-form-item prop="minSalary" v-if="form.jobType === 0">
                    <el-input class='w160' v-model.number="form.minSalary" placeholder="请输入薪资下限，单位元" maxlength="6"></el-input>
                    <el-input class='w160' v-model.number="form.maxSalary" placeholder="请输入薪资上限，单位元" maxlength="6"></el-input>
                </el-form-item>
                <el-form-item v-else prop="salaryOne">
                    <el-input class='w160' v-model.number="form.salaryOne" placeholder="请输入薪资，单位元" maxlength="6"></el-input>
                    <el-select v-model="form.salaryOneType">
                        <el-option v-for="item in salaryOneType" :label="item.value" :value="item.key" :key="item.kay"></el-option>
                    </el-select>
                </el-form-item>
            </el-form-item>
            <el-form-item label="工作地址:" prop="provinceId" required>
                <el-select v-model="form.provinceId" filterable placeholder="请选择省" @change="changeProvince">
                    <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <el-select v-model="form.cityId" filterable placeholder="请选择市">
                    <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <el-input class="w160" v-model="form.address" placeholder="请输入详细地址" />
            </el-form-item>
            <el-form-item label="职位描述:" prop="content">
                <div>温馨提示：单张图片上传不超过5MB（为了用户体验，98%主办方上传2MB以内，宽度620的海报图片，如需压缩可以使用<span class="img-zip-link" @click="openImgZip">在线压缩工具</span>）</div>
                <tinymce-editor ref="tiny" v-model="form.content" style="width:830px;"></tinymce-editor>
            </el-form-item>
        </el-form>
        <div class="clear noticeEditButton">
            <el-button type="small" class="fl qx" @click="goBack">取消</el-button>
            <el-button type="small" class="fl qx" @click="saveNotice('positionEditBox')">保存</el-button>
        </div>
    </div> 
</template>

<script>
import recruitPosition from '@/services/recruit/position';
import AreaService from '@/services/area';
import TinymceEditor from '@/components/tinymce/Index.vue';
export default {
    data() {
        var salary = (rule, value, callback) => {
            if (this.form.jobType == 0) {
                if(!this.form.minSalary || !this.form.maxSalary) {
                    callback(new Error('请输入薪资范围'))
                } else {
                    callback()
                }
            }
        }
        var provinceRule = (rule, value, callback) => {
            if(!this.form.provinceId || !this.form.cityId || !this.form.address) {
                callback(new Error('请输入活动地址'))
            } else {
                callback()
            }
        }
        return {
            form: {
                id: 0,
                salaryType: 0,
                jobType: 0,
                provinceId: '',
                cityId: '',
                address: '',
                content: '',
                minSalary: null,
                maxSalary: null,
                salaryOneType: 0
            },
            provinceList: [],
            cityList: [],
            modeData: [
                {
                    key: 0,
                    value: '面议'
                }, {
                    key: 1,
                    value: '非面议'
                }
            ],
            typeData: [
                {
                    key: 0,
                    value: '全职'
                }, {
                    key: 1,
                    value: '兼职'
                }
            ],
            salaryOneType: [
                {
                    key: 0,
                    value: '元/天'
                }, {
                    key: 1,
                    value: '元/次'
                }
            ],
            modalForm: {
                jobName: [{ required: true, message: '请输入职位名称', trigger: 'blur' }],
                minSalary: [{ validator: salary, trigger: 'blur' }],
                salaryOne: [{ required: true, message: '请输入单次薪资', trigger: 'blur' }],
                provinceId: [{ validator: provinceRule, trigger: 'blur' }],
                content: [{ required: true, message: '请输入职位描述', trigger: 'blur' }],
            },
            text: '<div><p>（以下为参考模板）</p><p>公司简介：</p><p>XXXX DanceStudio是上海市知名街舞机构，在普陀区、黄浦区分别开始3家分店，团队管理层5人，师资团队超过30人，累积授课学员超过2000人。其中，XX、XXX等在JD 2020、BIS 2020拿下8强成绩，曾多次邀请XXX、XX等本土OG授课。公司福利好，每周团训，创始人不定期分享授课经验和管理知识，欢迎你的加入！</p><p>岗位职责：</p><p>1、负责学员教学与课前备课，保证课程质量和氛围</p><p>2、负责定期抽查学员学习情况，提高学员满意度</p><p>3、有一定音乐储备和视频储备，有比赛经验和battle/练习视频讲解能力</p><p></p><p>岗位要求：</p><p>1、POPPING舞种具有舞龄3年以上，教龄1年以上经验</p><p>2、有一定的街舞知识储备和讲解能力</p><p>3、性格开朗，做事认真负责，能带起氛围</p></div>'
        }
    },
    created() {
        this.form.id = this.$route.query.id || null;
        this.form.id ? this.queryPositionById() : this.form.content = this.text;
        this.initArea('province', '0');
    },
    components: {
        TinymceEditor
    },
    methods: {
        // 初始化省份
        async initArea (type, pid) {
            const { code, message, result } = await AreaService.areaByParentIdApi(pid);
            if (Object.is(code, 0)) {
                this[`${type}List`] = result;
            } else {
                console.error(`获取${type}失败`, message);
            }
        },
        // 修改省的时候
        changeProvince (ev) {
            if (ev) {
                this.initArea('city', ev);
            }
            this.form.cityId = '';
            this.cityList = [];
        },
        queryPositionById() {
            recruitPosition.jobDetails(this.form.id).then(res => {
                this.changeProvince(res.result.provinceId);
                this.form = res.result;
                this.form.content = this.form.content || this.text
            }).catch(() => {})
        },
        openImgZip () {
            window.open('http://www.secaibi.com/tools/', '_blank');
        },
        goBack() {
            this.$router.go(-1)
        },
        saveNotice(e) {
            this.$refs[e].validate((valid) => {
                if (!valid) return false;
                if(this.form.id) {
                    recruitPosition.jobUpdata(this.form.id, this.form).then(res => {
                        if(res.code == 1) {
                            this.$message.error(res.message)
                            return false;
                        } else {
                            this.$message.success('编辑成功')
                            this.$router.push({name: 'recruit/position'})
                        }
                    })
                } else {
                    recruitPosition.jobAdd(this.form).then(res => {
                        if (res.code == 0) {
                            this.$message.success('新增成功')
                            this.$router.push({name: 'recruit/position'})
                        } else {
                            this.$message.error(res.message)
                        }
                        
                    }).catch(() => {})
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.positionEditBox{
    .w160 {
        width: 200px;
        margin-bottom: 0;
        margin-top: 4px;
    }
    .w400{
        width: 400px;
    }
    .noticeEditButton{
        margin-top: 10px;
        padding-left: 100px;
        .qx{
            margin-right: 20px;
        }
    }
}
</style>
